import React from "react";

// Horizontal tab bar (e.g. Visit Info / Book Distribution / Routes Plan /
// Accommodation / Media and Advice within an expanded city).
export default function TspTabs({ tabs, active, onChange, className = "" }) {
  return (
    <div className={`tsp-tabs ${className}`} role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab}
          type="button"
          role="tab"
          aria-selected={tab === active}
          className={`tsp-tab ${tab === active ? "active" : ""}`}
          onClick={() => onChange(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
